import React from "react";
import logo from "./logo.svg";
import "./App.css";
import ThemeToggle from "./components/ThemeToggle";
import Home from "./pages/Home";

function App() {
  return (
    <>
      <ThemeToggle />
      <Home />
    </>
  );
}

export default App;
